import { render, staticRenderFns } from "./specialized-new-zone-bid-announcement.vue?vue&type=template&id=aee181ee&scoped=true"
import script from "./specialized-new-zone-bid-announcement.vue?vue&type=script&lang=js"
export * from "./specialized-new-zone-bid-announcement.vue?vue&type=script&lang=js"
import style0 from "./specialized-new-zone-bid-announcement.vue?vue&type=style&index=0&id=aee181ee&prod&lang=css"
import style1 from "./specialized-new-zone-bid-announcement.vue?vue&type=style&index=1&id=aee181ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee181ee",
  null
  
)

export default component.exports